import React from 'react';
import { Container } from 'react-bootstrap';
import { withAuthorization } from '../Session';
import TransactionsList from './List'
class InstaTransaction extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Container>
                <TransactionsList {...this.props}></TransactionsList>
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(InstaTransaction);
